module.exports = __webpack_public_path__ + "img/AccountCircleOutlined.4ac13327.svg";